import React from "react"

import { StyledListHeadingNew } from "./styles"
import { Typography, useTheme } from "@mui/material"
import { ListHeadingTypes } from "../types"
import Icon from "@mdi/react"
import { mdiChevronDown, mdiChevronUp } from "@mdi/js"
import tokens from "themes/default/tokens"

const ListHeading: React.FC<ListHeadingTypes> = (props) => {
  const { title, caret, variant } = props
  const theme = useTheme()

  return (
    <StyledListHeadingNew
      className="list-heading"
      sx={{
        padding: caret !== "NONE" ? "11px" : "0",
        background: caret !== "NONE" ? "#EEE" : "transparent",
        borderRadius: caret === "DOWN" ? "4px" : "4px 4px 0 0",
      }}
      theme={theme}
    >
      <Typography
        component={"div"}
        sx={{
          fontSize: caret !== "NONE" || variant !== "PRIMARY" ? "16px" : "20px",
          fontWeight: variant === "PRIMARY" ? 600 : 500,
        }}
        color={variant === "PRIMARY" ? tokens.color.primary : "black"}
      >
        {title}
      </Typography>
      {caret !== "NONE" && (
        <Icon
          path={caret === "DOWN" ? mdiChevronDown : mdiChevronUp}
          size={"24px"}
          style={{ marginLeft: "auto" }}
        />
      )}
    </StyledListHeadingNew>
  )
}

export default ListHeading
